import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { NotificationComponent } from './shared/components/notification/notification.component';
import { AuthService } from './auth/service/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { PublicService } from './core/services/shared-services/public/public.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports:[ RouterModule, NotificationComponent,LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  private auth = inject(AuthService);
  private destroyRef = inject(DestroyRef);
  private publicConfig = inject(PublicService);

  ngOnInit() {
    // this.getPublicConfig();
  }
  
  getPublicConfig() {
    this.auth.getPublicConfig().pipe(
      takeUntilDestroyed(this.destroyRef),
      map((response:any) => {
       this.publicConfig.setPublicData(response)
      }),
    ).subscribe();
  }
}
